import axios from "axios";
import { useEffect, useState } from "react";

export default function WhatsAppTab() {
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [list, setList] = useState([]);
  const [editId, setEditId] = useState(null);

  const API = "https://notification-dashboard-fullstack.onrender.com/api/whatsapp";

  const isValidNumber = (num) => /^[0-9]{10,15}$/.test(num);

  const load = async () => {
    const res = await axios.get(API);
    setList(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();

    if (!mobile || !message) {
      alert("⚠️ All fields required");
      return;
    }

    if (!isValidNumber(mobile)) {
      alert("❌ Invalid mobile number");
      return;
    }

    const data = { mobile, message };

    if (editId) {
      await axios.put(`${API}/${editId}`, data);
    } else {
      await axios.post(API, data);
    }

    setMobile("");
    setMessage("");
    setEditId(null);
    load();
  };

  return (
    <>
      <form onSubmit={submit}>
        <input
          type="tel"
          className="form-control mb-2"
          placeholder="WhatsApp Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />

        <textarea
          className="form-control mb-2"
          placeholder="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button className="btn btn-success">
          {editId ? "Update WhatsApp" : "Send WhatsApp"}
        </button>
      </form>

      <table className="table table-hover mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Mobile</th>
            <th>Message</th>
            <th>Time</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {list.map((w, i) => (
            <tr key={w._id}>
              <td>{i + 1}</td>
              <td>{w.mobile}</td>
              <td>{w.message}</td>
              <td>{new Date(w.createdAt).toLocaleString()}</td>
              <td>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => {
                    setMobile(w.mobile);
                    setMessage(w.message);
                    setEditId(w._id);
                  }}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() =>
                    axios.delete(`${API}/${w._id}`).then(load)
                  }
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
